///////////////////////////////////////
///              POZOR              ///
// jakakoliv zmena zde muze zpusobit
// ze preastane fungovat potomek v ServicesFactory.ts
// je nutne dodelat import a export nove pridaneho interface
// je nutne dodelat zmeny v metodach, ktere tam jsou prepsane
// a to v jakemkoliv projektu TL.ISDISP, TL.Michael, TL.ShiftDuck
///////////////////////////////////////

import { AxiosResponse } from "./CoreBase";

export abstract class ServicesFactoryBase {
	public static getReceiverService(): IReceiverService | null {
		return null;
	}

	public static getReceiverFilter(idTenant?: number | null, idTag?: number | null): any | null {
		return null;
	}

	public static getContentPreviewService(): IContentPreviewService | null {
		return null;
	}

	public static getContentService(): IContentService | null {
		return null;
	}
}



export interface IReceiverService {
	getPreviewById(id: number): Promise<AxiosResponse>;
	getAllByFilter(filter: any): Promise<AxiosResponse>;
}

export interface IContentPreviewService {
	getById(id: number): Promise<AxiosResponse>;
}

export interface IContentService {
	getOriginalFileById(id: number): Promise<AxiosResponse>;
}
